import { render } from "./PeachEn.vue?vue&type=template&id=5acec2e3"
import script from "./PeachEn.vue?vue&type=script&lang=js"
export * from "./PeachEn.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__